import {
  AfterViewInit,
  Component,
  computed,
  input,
  output,
  Signal,
  signal,
  inject,
} from '@angular/core';
import { Button } from 'primeng/button';
import { PrimengButtonDirective, PrimengDialogDirective } from '@web/shared/ui';
import { Guid, isNil, Nillable, valueOrDefault } from '@web/utils';
import { MultimediaAttributesComponent } from '../../components/multimedia-attributes/multimedia-attributes.component';
import { MultimediaGridComponent } from '../multimedia-grid/multimedia-grid.component';
import { MultimediaGridFilterComponent } from '../../components/multimedia-grid-filter/multimedia-grid-filter.component';
import { AdminFetchMultimediaByIdPipe } from '../../pipes/admin-fetch-multimedia-by-id.pipe';
import { AsyncPipe } from '@angular/common';
import { MultimediaType } from '../../../shared/enums/multimedia-type';
import { AdminMultimediaGridFilter } from '../../models/admin-multimedia-grid-filter';
import { MultimediaGridService } from '../multimedia-grid/multimedia-grid.service';
import { Dialog } from 'primeng/dialog';
import { MultimediaUploadComponent } from '../multimedia-upload/multimedia-upload.component';

@Component({
  selector: 'app-multimedia-choose-multiple',
  imports: [
    MultimediaGridComponent,
    Button,
    PrimengButtonDirective,
    MultimediaAttributesComponent,
    MultimediaGridFilterComponent,
    AdminFetchMultimediaByIdPipe,
    AsyncPipe,
    Dialog,
    MultimediaUploadComponent,
    PrimengDialogDirective,
  ],
  templateUrl: './multimedia-choose-multiple.component.html',
  styleUrl: './multimedia-choose-multiple.component.scss',
  providers: [MultimediaGridService],
})
export class MultimediaChooseMultipleComponent implements AfterViewInit {
  private readonly multimediaGrid = inject(MultimediaGridService);

  public readonly allowedMultimediaTypes = input<Nillable<MultimediaType[]>>();

  public readonly confirmSelectedEvent = output<Guid[]>();

  protected readonly isSelected = this.isSelectedSignal();
  protected readonly selected = signal<Nillable<Guid[]>>(null);
  protected readonly lastSelected = this.lastSelectedSignal();
  protected uploadDialogVisibility = false;

  public ngAfterViewInit(): void {
    this.multimediaGrid.filter(
      AdminMultimediaGridFilter.fromPartial({
        type: this.allowedMultimediaTypes(),
      }),
    );
  }

  public handleSelectionChangeEvent(ids: Guid[]): void {
    this.selected.set(ids);
  }

  public handleFilterChange(filter: AdminMultimediaGridFilter): void {
    this.multimediaGrid.filter(
      AdminMultimediaGridFilter.copyOf(filter, {
        type: this.allowedMultimediaTypes(),
      }),
    );
  }

  public handleChooseClick(): void {
    const selected = this.selected();

    if (isNil(selected)) {
      return;
    }

    this.confirmSelectedEvent.emit(selected);
  }

  public handleUploadClickEvent(): void {
    this.uploadDialogVisibility = true;
  }

  public handleUploadedEvent(): void {
    this.multimediaGrid.refresh();
  }

  public handleUploadCloseClickEvent(): void {
    this.uploadDialogVisibility = false;
  }

  protected isSelectedSignal(): Signal<boolean> {
    return computed(() => !isNil(this.selected()));
  }

  protected lastSelectedSignal(): Signal<Nillable<Guid>> {
    return computed(() => {
      const [first] = [...valueOrDefault(this.selected(), [])].reverse();

      return first;
    });
  }
}
